export default "__VITE_ASSET__DXKE19QR__"